export default {"src":"/_next/static/media/visible-off.57ddb5ae.svg","height":24,"width":23};